export default __webpack_public_path__ + "4290fee.mp3";